import React, { useState } from 'react';
import { Grid, Typography, ListItem, IconButton, Divider } from '@mui/material';
import Enumerable from 'linq';
import DetalleSubModulo from './DetalleSubModulo';

import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';

import { styleDetalleModulo } from '../Tool/Style';

import { createStyles, makeStyles } from '@mui/styles';

const useStyles = makeStyles(() =>
    createStyles({
        customAccordionSummary: {
            justifyContent: 'space-around',
            margin: '20px 0px 20px 32px !important'
        }
    }));

const DetalleModulo = ({ listaSubmodulos, Header, Detalles, LastOne }) => {
    const classes = useStyles();
   
    const [expanded, setExpanded] = useState(true);
    const [expandedFavoritos, setExpandedFavoritos] = useState(false);

    return (
        <ListItem style={styleDetalleModulo.ListItem}>
            {
                Detalles ?
                    (
                        <div style={styleDetalleModulo.divDetallesFull}>
                            <img src={Enumerable.from(listaSubmodulos).first().Imagen} style={styleDetalleModulo.imgArea} alt={"Favoritos"} onClick={() => setExpandedFavoritos(!expandedFavoritos)} />
                            <Accordion elevation={0} square expanded={expandedFavoritos} style={{ backgroundColor: 'transparent' }}>
                                <AccordionSummary classes={{ content: classes.customAccordionSummary }}
                                    expandIcon={<IconButton
                                        style={styleDetalleModulo.IconExpansionPanelSummary}
                                        onClick={() => setExpandedFavoritos(!expandedFavoritos)}
                                        size="large">
                                        <ExpandMoreIcon color='primary' /></IconButton>}>
                                    <Typography onClick={() => setExpandedFavoritos(!expandedFavoritos)} variant='h5' >{Header}</Typography>
                                </AccordionSummary>
                                <AccordionDetails>
                                    <Typography variant='h6'>{Enumerable.from(listaSubmodulos).first().Leyenda}</Typography>
                                    <Grid container spacing={2} justifyContent="center" style={styleDetalleModulo.gridDetalles}>
                                        {
                                            listaSubmodulos.map(({ IdModulo, Titulo, Submodulo, UrlModulo, Icono, Acceso, Referencia, ModuloExterno }, key) =>
                                                Acceso ? (<DetalleSubModulo key={key} IdModulo={IdModulo} Titulo={Titulo} Submodulo={Submodulo} UrlModulo={UrlModulo} Icono={Icono} Detalles={Detalles} Referencia={Referencia} ModuloExterno={ModuloExterno} />) : (null)
                                            )
                                        }
                                    </Grid>
                                </AccordionDetails>
                            </Accordion>
                            {LastOne ? null : <Divider style={{ marginTop: 30 }} />}
                        </div>
                    )
                    :
                    (
                        <div style={styleDetalleModulo.divDetalles}>
                            <div style={{ textAlign: 'center' }}>
                                <Accordion elevation={0} style={styleDetalleModulo.Accordion} square expanded={expanded}>
                                    <AccordionSummary style={styleDetalleModulo.Accordion} classes={{ content: classes.customAccordionSummary }}
                                        expandIcon={<IconButton
                                            style={styleDetalleModulo.IconExpansionPanelSummary}
                                            onClick={() => setExpanded(!expanded)}
                                            size="large">
                                            <ExpandMoreIcon color='primary' /></IconButton>}>
                                        <Typography onClick={() => setExpanded(!expanded)} variant='h5' >{Header}</Typography>
                                    </AccordionSummary>
                                    <AccordionDetails>
                                        <Grid container spacing={2} justifyContent="center" style={styleDetalleModulo.gridDetalles}>
                                            {
                                                listaSubmodulos.map(({ IdModulo, Titulo, Submodulo, UrlModulo, Icono, Acceso, Referencia, ModuloExterno }, key) =>
                                                    Acceso ? (<DetalleSubModulo key={key} IdModulo={IdModulo} Titulo={Titulo} Submodulo={Submodulo} UrlModulo={UrlModulo} Icono={Icono} Detalles={Detalles} Referencia={Referencia} ModuloExterno={ModuloExterno} />) : (null)
                                                )
                                            }
                                        </Grid>
                                    </AccordionDetails>
                                </Accordion>
                            </div>
                        </div>
                    )
            }
        </ListItem>
    );
}

export default DetalleModulo;